import { Trans } from 'react-i18next'
import { StyleSheet, View } from 'react-native'
import { useParams } from 'zens-router'
import { Button, Spacing, Text } from 'zens-storybook'

const styles = StyleSheet.create({
  container: {
    flex: 1,
    padding: Spacing.M,
  },
  text: {
    textAlign: 'center',
    marginBottom: Spacing.M,
  },
})

interface Props {
  onStart?: (file: string) => void
}

const FirmwareStart = (props: Props) => {
  const { onStart } = props
  const [{ file }] = useParams()

  return (
    <View style={styles.container}>
      <Text style={styles.text}>
        <Trans>
          Remove your phone from the charger and turn the charger power off and on. After beep press update button
          below.
        </Trans>
      </Text>
      <Button title="Update" onPress={() => onStart?.(file)} testID="FirmwareStart.Update" />
    </View>
  )
}

export default FirmwareStart
